import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/client';

const MAX_VISIBLE = 5;

export default function Header() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get('q') || '');
  const [categories, setCategories] = useState([]);
  const [moreOpen, setMoreOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const moreRef = useRef(null);
  const activeCategorySlug = searchParams.get('categorySlug') || '';

  useEffect(() => {
    api.get('/api/public/categories')
      .then((res) => setCategories(res.data.filter((c) => !c.parent)))
      .catch(() => {});
  }, []);

  // 드롭다운 외부 클릭 시 닫기
  useEffect(() => {
    const handler = (e) => {
      if (moreRef.current && !moreRef.current.contains(e.target)) {
        setMoreOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // 드로어 열릴 때 스크롤 잠금
  useEffect(() => {
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  const handleSearch = (e) => {
    e.preventDefault();
    const q = query.trim();
    navigate(q ? `/?q=${encodeURIComponent(q)}` : '/');
  };

  const closeDrawer = () => setDrawerOpen(false);

  const isHome = !activeCategorySlug && !searchParams.get('q');
  const visibleCats = categories.slice(0, MAX_VISIBLE);
  const hiddenCats = categories.slice(MAX_VISIBLE);
  const hasMore = hiddenCats.length > 0;
  const activeInHidden = hiddenCats.some((c) => c.slug === activeCategorySlug);

  return (
    <>
      <header className="pub-nav">
        {/* 모바일 햄버거 버튼 */}
        <button
          className="pub-nav-hamburger"
          onClick={() => setDrawerOpen(true)}
          aria-label="카테고리 메뉴 열기"
        >
          ☰
        </button>

        <Link to="/" className="pub-brand">HOBBYGOM.</Link>

        <nav className="pub-nav-links">
          <Link to="/" className={`pub-nav-link${isHome ? ' active' : ''}`}>
            ALL
          </Link>
          {visibleCats.map((cat) => (
            <Link
              key={cat.id}
              to={`/?categorySlug=${cat.slug}`}
              className={`pub-nav-link${activeCategorySlug === cat.slug ? ' active' : ''}`}
            >
              {cat.name.toUpperCase()}
            </Link>
          ))}

          {hasMore && (
            <div className="pub-nav-more" ref={moreRef}>
              <button
                className={`pub-nav-link pub-nav-more-btn${activeInHidden ? ' active' : ''}`}
                onClick={() => setMoreOpen((v) => !v)}
                aria-expanded={moreOpen}
              >
                MORE ▾
              </button>
              {moreOpen && (
                <div className="pub-nav-dropdown">
                  {hiddenCats.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/?categorySlug=${cat.slug}`}
                      className={`pub-nav-dropdown-item${activeCategorySlug === cat.slug ? ' active' : ''}`}
                      onClick={() => setMoreOpen(false)}
                    >
                      {cat.name.toUpperCase()}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          )}
        </nav>

        <form className="pub-search" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="SEARCH"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="pub-search-input"
          />
        </form>
      </header>

      {/* 모바일 카테고리 드로어 */}
      {drawerOpen && (
        <div className="pub-drawer-overlay" onClick={closeDrawer} />
      )}
      <div className={`pub-drawer${drawerOpen ? ' open' : ''}`} aria-hidden={!drawerOpen}>
        <div className="pub-drawer-header">
          <span className="pub-drawer-brand">HOBBYGOM.</span>
          <button className="pub-drawer-close" onClick={closeDrawer} aria-label="닫기">✕</button>
        </div>
        <nav className="pub-drawer-nav">
          <Link
            to="/"
            className={`pub-drawer-link${isHome ? ' active' : ''}`}
            onClick={closeDrawer}
          >
            전체 글
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/?categorySlug=${cat.slug}`}
              className={`pub-drawer-link${activeCategorySlug === cat.slug ? ' active' : ''}`}
              onClick={closeDrawer}
            >
              {cat.name}
            </Link>
          ))}
        </nav>
        <form className="pub-drawer-search" onSubmit={(e) => { handleSearch(e); closeDrawer(); }}>
          <input
            type="text"
            placeholder="검색어 입력"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button type="submit">검색</button>
        </form>
      </div>
    </>
  );
}
